import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const GameCountdown = ({ gameDate, opponent, isHome }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    // W.C. Gordon Classic: Tuskegee @ Jackson State - Sep 19, 2026 6:00 PM CST
    const gameDateTime = new Date('2026-09-19T18:00:00');
    const now = new Date();
    const difference = gameDateTime - now;

    if (difference <= 0) {
      return { expired: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (timeLeft.expired) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-[#DC2626] to-[#991B1B] text-white py-4 overflow-hidden" data-testid="countdown-ticker">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center space-x-4 animate-pulse">
          <Clock className="h-6 w-6" />
          <div className="text-center">
            <p className="text-sm uppercase tracking-wider font-bold mb-1">
              🏈 W.C. Gordon Classic: Tuskegee @ Jackson State
            </p>
            <div className="flex items-center space-x-4 text-2xl md:text-3xl font-bold heading-font">
              <div className="flex flex-col items-center">
                <span>{timeLeft.days}</span>
                <span className="text-xs font-normal">DAYS</span>
              </div>
              <span className="text-3xl">:</span>
              <div className="flex flex-col items-center">
                <span>{String(timeLeft.hours).padStart(2, '0')}</span>
                <span className="text-xs font-normal">HRS</span>
              </div>
              <span className="text-3xl">:</span>
              <div className="flex flex-col items-center">
                <span>{String(timeLeft.minutes).padStart(2, '0')}</span>
                <span className="text-xs font-normal">MIN</span>
              </div>
              <span className="text-3xl">:</span>
              <div className="flex flex-col items-center">
                <span>{String(timeLeft.seconds).padStart(2, '0')}</span>
                <span className="text-xs font-normal">SEC</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCountdown;
